import React from "react";
import {Link} from "react-router";
import { debounce } from "lodash";
import i18n from 'i18n-js';


import Right from "./Right";
import FormItem from "./FormItem";
import Panel from "./Panel";
import Maps from "./Maps";
import ExcellFilter from "./UI/ExcellFilter";

import ChartMaker from "./UI/ChartMaker/ChartMaker";//import ChartMaker from "./ChartMaker";
import ChartMaker2 from "./ChartMaker";

import CoolLoader from "./CoolLoader";
import CoolLoader2 from "./CoolLoader2";
import {api, formatQuestionResponse, parsePHPtime, obsDataParser, findAnswer, actionColors, smileys} from "./baseFunctions";
import {Table, Column} from 'react-virtualized';
// import Column from "./UI/Column.js";

import langs from "./langs/appIndex";
import phpLangs from "./langs/phpIndex";

import {history} from '../store.js';


// import Particles from "react-tsparticles"; // import the tsParticles component
// import { loadConfettiShape } from "tsparticles-shape-confetti"; // import the confetti shape
// Confetti: https://dev.to/matteobruni/how-to-create-beautiful-confetti-animations-with-tsparticles-193

import "./css/dashboard.css";
import './css/virtualTable.css'; 

export default class Observations extends React.Component {
	constructor(props){
		super(props);
    this.getData = this.getData.bind(this);
    this.getOBS = this.getOBS.bind(this);
    this.drawChart = this.drawChart.bind(this);
    this.preloadReport = this.preloadReport.bind(this);
    this.deleteObs = this.deleteObs.bind(this);
    this.getDepartmentList = this.getDepartmentList.bind(this);
    this.getDepartmentListRek = this.getDepartmentListRek.bind(this);
    this.overViewTable = false;
		this.state = {
      modalImages: [],
      modalI: 0,

			data: false,
      showExtObs: false,
      departments: [],
      tableWidth: window.innerWidth-420,
      departmentsRaw: null,
      myDeps: [],
      users: [],
      extraFields: [],
      keyBuster: 0,
      showReport: props.params.id ? Number(props.params.id) : false,
      reportData: {
        address: "",
        anon: "",
        createdBy: "",
        time: "",
        gps: [],
        questions: [],
        history: [],
        images: [],
      },

      extras: [],
      sheets: [],
      sortCol: "unix",
      sortType: "desc",
      search: "",
      searchData: [],
      loading: {},
      hasCase: false,

      showFilter: false,
      filterData: [],
      filterKey: false,
      filterX: 0,
		};
  }
  _sendUpdate = false;

	componentDidMount(){
    window.addEventListener("resize", this.updateTable);
    console.log("Componetndidmount", this.getData, this.getData());
		const getD = this.getData();
    if(!getD)
    {
      return;
    }
    getD.then(_ => {
      if(this.props.params.id)
      {
        this.getOBS(this.props.params.id);
      }
    }).catch(() => {});
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateTable);
  }
  updateTable = () => {
    this.setState({
      tableWidth: window.innerWidth - 420
    })
  }
	componentDidUpdate(prevProps, prevState)
	{

    if(prevProps.params.group !== this.props.params.group)
    {
      this.setState({
        data: false,
      });
      this.getData();
    }else if(prevProps.params.id !== this.props.params.id)
    {
      this.preloadReport(Number(this.props.params.id));
    }
	}
  preloadReport(id){
    const curr = this.state.data.find((d) => d.id === id);
    // console.log("preloadReport", id, curr);
    var data = {...this.state.reportData};
    //console.log("Curr", curr);
    for(var key in data.data)
    {
      data.data[key] = "";
    }
    data.address = curr && curr.address ? curr.address : "";
    data.anon = curr && curr.anon ? curr.anon : "";
    data.gps = curr && curr.gps ? curr.gps : [];
    data.questions = false;
    data.history = [];
    data.images = [];
    this.setState({reportData: data, showReport: curr ? Number(curr.id) : false});
    if(curr)
    {
      this.getOBS(curr.id);
    }
  }

  getOBS(id)
  {
    api("POST", {"type": "getReport", id}, (d) => {
      if(!d.error)
      {
        d.data.sheet = this.state.sheets.find(sheet => sheet.id === d.data.sheetID);
        // console.log("GetOBS sheet", d.data.sheet, this.state.sheets, d.data);
        let pointCheck = d.data.sheet.questions.filter(question => question.type === "points");
        this.setState({reportData: {
          ...d.data,
          points: 0//pointCheck.length > 0 ? pointCheck.reduce((num, curr) => num + Number(curr.response[0] || 0), 0) : false,
        }});
        if(this.refs.status)
        {
          this.refs.status.value = d.data.status;
        }

        obsDataParser(d.data).then(data => {
          this.setState({
            reportData: data,
          });
        });
        //DAWA
      }else{
        alert(d.msg);
      }
    }, this.props.auth, 1);
  }

  deleteObs(key, d)
  {
    var sure = window.confirm(phpLangs[this.props.lang].REMOVE_OBS_MSG + d.id);
    if(!sure)
    {
      return 1;
    }
    api("POST", {"type": "deleteObs", id: d.id}, (d) => {
      if(!d.error)
      {
        this.setState({
          data: false,
        });
        this.getObsData(1);
      }
    }, this.props.auth, true);
  }

  drawChart(d){
    var ctx = this.canvas;
    var dataSet = {};
    d.map((d, key) => {
      if(Object.keys(dataSet).length < 30 && d.points > 0)
      {
        var date = new Date(d.time * 1000);
        var index = date.getDate() + "/" + date.getMonth(); 
        dataSet[index] = dataSet[index] ? dataSet[index] + d.points : d.points;
      }
    });
    var largestY = 0;
    var chart = new window.Chart(ctx, {
        type: 'line',
        data: {
            labels: Object.keys(dataSet),
            datasets: [{
                label: "Point",
                backgroundColor: 'rgba(42, 63, 84, 0.74)',
                borderColor: 'rgba(42, 63, 84, 0.74)',
                data: Object.keys(dataSet).map((key) => {
                  var curr = dataSet[key];
                  if(curr > largestY)
                  {
                    largestY = curr;
                  }
                  return curr;
                }),
            }]
        },

        // Configuration options go here
        options: {
          scales: {
        yAxes: [{
                  display: true,
                  ticks: {
                      beginAtZero: true,
                      steps: 10,
                      stepValue: 5,
                      max: largestY
                  }
              }]
    }
        }
    });
  }

  _gettingData = false;
  getObsData = (fresh = true) => {
    const group = this.props.groups.find(d => d.id == this.props.routeParams.group);
    if(!group || this._gettingData)
    {
      return;
    }
    // fresh = false;
    let data = {"type": "getReports", sheets: group.sheets.map(d => d.id), "firstLoad": !!fresh, "sort": fresh ? "unix" : "default", "extraFields": this.state.extraFields.map((d) => d.id)};
    if(!fresh && this.state.data.length > 0)
    {
      data.fromID = this.state.data[this.state.data.length - 1].id;
    }
    // console.log("Requestion", data, new Error(), this._gettingData);
    
    return new Promise(r => api("POST", data, (d) => {
        if(!d.error)
        {
          let data = d.data.reports;//fresh ? d.data : {...this.state.data};
          // if(!fresh)
          // {
          //   data = [
          //     ...data,
          //     ...d.data
          //   ];
          // }
          this.setState({
            sheets: d.data.sheets.length > 0 ? d.data.sheets : this.state.sheets,
            extras: d.data.extras.length > 0 ? d.data.extras : this.state.extras,
            hasCase: fresh ? d.data.hasCase : this.state.hasCase,
            data,
            searchData: data
          });
          requestAnimationFrame(() => r());
          if(fresh)
          {
            this.getObsData(false)
          }else if(this.state.search.length > 0 || !fresh)
          {
            // requestAnimationFrame(() => this.parseData());
          }
          requestAnimationFrame(() => this.parseData());
        }
      }, this.props.auth, 1));
  }
	getData(){
    api("POST", {"type": "getUsers"}, (d) => {
      if(!d.error)
      {
        this.setState({users: d.data});
      }
    }, this.props.auth, 1);
    api("POST", {"type": "getDepartments"}, (d) => {
      if(!d.error)
      {
        this.setState({departments: d.data, myDeps: d.mine.map(d => Number(d))});
      }
    }, this.props.auth, 1);
    // api("POST", {"type": "getRawDepartments"}, (d) => {
    //   if(!d.error)
    //   {
    //     this.setState({departmentsRaw: d.data});
    //   }
    // }, this.props.auth, 1);

    // api("POST", {"type": "getExtraFields", page: "observation"}, (extraFieldData) => {
    //   this.setState({
    //     extraFields: extraFieldData.data
    //   });
    // }, this.props.auth, 1);
    return this.getObsData(1);
	}

  getDepartmentListRek(target, list)
  {
    //let ret = [];
    //console.log("getDepartments", target, list);
    for(let i = 0; i < list.length; i++)
    {
      let curr = list[i];
      if(curr.id === target)
      {
        return [curr.name];
      }
    }
    for(let i = 0; i < list.length; i++)
    {
      let curr = list[i];
      if(curr.subDepartments.length > 0)
      {
        let temp = this.getDepartmentListRek(target, curr.subDepartments);
        if(temp)
        {
          return [curr.name, ...temp];
        }
      }
    }
    return false;
    //return ret.join(" > ");
  }
  getDepartmentList(target, list = [])
  {
    //console.log("getDepartments", target, list);
    if(list)
    {
      let temp = this.getDepartmentListRek(Number(target), list);
      if(temp)
      {
        return temp.join(" > ");
      }
    }
    return "";
  }
  shareObs = (data) => {
    const LANG = phpLangs[this.props.lang];
    let check = prompt(LANG.SHARE_COMMENT);
    
    if(check !== null)
    {
      //console.log(check, data);
       api("POST", {"type": "shareObs", comment: check, id: data.id, hash: data.hash}, () => {
          //alert("Saved");
       }, this.props.auth, 1);
    }
  }
  parseData = (search = this.state.search) => {
    let data = this.state.data;
    const { sortCol, sortType} = this.state;
    let ret = [...data].map(d => {
      d.extraField = d.extras.map(d => (d.textAnswer || d.answer).toLowerCase());//[];//this.state.data.extras.find(dat => dat.parentID == d.id);
      d.extraFieldText = d.extraField.join(", ");

      return d;
    });

    if (sortCol && sortType) {
      ret = ret.sort((a, b) => {
        let x = a[sortCol];
        let y = b[sortCol];
        if(sortCol === "createdBy")
        {
          x = x.name;
          y = y.name;
        }else if(sortCol === "unix")
        {
          x = Number(x);
          y = Number(y);
        }else if(sortCol === "extraField")
        {
          x = x.extraFieldText;
          y = y.extraFieldText;
        }
        if (typeof x === 'string') {
          x = x.charCodeAt(0);
        }
        if (typeof y === 'string') {
          y = y.charCodeAt(0);
        }
        if (sortType === 'ASC') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    
    if(search && search.length > 0)
    {
      const LANG = phpLangs[this.props.lang];
        ret = ret.filter(data => !!(Object.keys(data).some((d, key) => {
          switch(d){
            // case "status":
            //     const isOwnDepartment = data.department ? this.state.myDeps.indexOf(Number(data.department)) !== -1 : true;
            //     let customStatus = !isOwnDepartment ? 3 : data.status;
            //     return search && LANG.STATUS_ARR[customStatus].toLowerCase().includes(search.toLowerCase());
            // break;
            case "createdBy":
                return search && data[d] && data[d].toString().toLowerCase().includes(search.toLowerCase());
            break;

            // STARTED_DATE
          case "department":
              return ((data.departmentName || "") + "#" + data.department).toLowerCase().includes(search.toLowerCase());
          break;
          case "unix":
            return parsePHPtime(data[d] / 1000).includes(search.toLowerCase());
          break;
          // case "extraField":
          //     return data.extraField && data.extraField[LANG.key].toLowerCase().includes(search.toLowerCase());
          // break;
            case "extraField":
              return (data.extraField || []).some(d => d.includes(search.toLowerCase()));//.includes(search.toLowerCase());
            break;
            case "status":
                return LANG.STATUS_ARR[data.status].includes(search.toLowerCase());
            break;
            default:
                return search && data[d] && data[d].toString().toLowerCase().includes(search.toLowerCase());
            break;
          }
        })));
    }

    console.log("Sorting..");
    this.setState({
     searchData: ret,
     keyBuster: this.state.keyBuster + 1,
   });
  //  requestAnimationFrame(() => {
  //   setTimeout(() => this.setState({
  //     searchData: ret
  //   }), 100);
  //  });
   /*requestAnimationFrame(() => 
   this.setState({
      searchData: ret
    }));*/
}

  keyFormatter(key, data)
  {
    const LANG = phpLangs[this.props.lang];
    const d = key;
    switch(d){
      // case "status":
      //     const isOwnDepartment = data.department ? this.state.myDeps.indexOf(Number(data.department)) !== -1 : true;
      //     let customStatus = !isOwnDepartment ? 3 : data.status;
      //     return search && LANG.STATUS_ARR[customStatus].toLowerCase().includes(search.toLowerCase());
      // break;
      // case "createdBy":
      //     return d.toString();//.toLowerCase().includes(search.toLowerCase());
      // break;

      // STARTED_DATE
    case "department":
      const dep = this.state.data.find(d => d.department === data);
      if(dep)
      {
         return dep.departmentName;
        break;
      }
    case "unix":
      return parsePHPtime(data / 1000);//.includes(search.toLowerCase());
    break;
    // case "extraField":
    //     return data.extraField && data.extraField[LANG.key].toLowerCase().includes(search.toLowerCase());
    // break;
      // case "extraField":
      //   return (data.extraField || []).some(d => d.includes(search.toLowerCase()));//.includes(search.toLowerCase());
      // break;
      case "status":
          return LANG.STATUS_ARR[data];//.includes(search.toLowerCase());
      break;
      default:
          return data.toString();//.toLowerCase().includes(search.toLowerCase());
      break;
    }
  }

  extraFieldFormatter(type, data)
  {
    if(type === "smileys")
    {
      if(data.length > 0)
      {
        return data.map(resp => <img src={`/includes/images/smiley/${smileys[Number(resp.answer)]}.png`} style={{width: "25px"}}/>);
      }
      return "";
    }

    return data.map(d => d.textAnswer || d.answer).join(", ");
  }

  switchModal(i)
  {
    this.setState({
      modalI: i
    })
  }

  checkedObs = [];

	render(){
    const repData = this.state.reportData;
    const phpLang = phpLangs[this.props.lang];
    const LANG = phpLangs[this.props.lang];
    const APP_LANG = langs[this.props.lang];
    const group = this.props.groups.find(d => d.id == this.props.routeParams.group);

    var currDeg = 0;

    /*    OLD TYPES     */
    const type = ["Usikre forhold", "Nærved hændelse", "Ulykke", "Positiv observation"];
    const konsType = ["Person", "Materiel", "Miljø", "Andet"];
    const action = ["Ingen handling nødvendig", "Problem løst for nu",  "Kan vente", "Haster", "Stop arbejde"];
    /*                  */
    let duplicateIDs = [];
    let checkBoxes = [];

    const extras = this.state.extras.map(id => {
      const sheets = this.state.sheets.map(sheet => findAnswer(sheet.questions, id));
      return sheets.find(d => d !== false);
    }).filter(d => d);

    const SHOW_REPORT = typeof this.state.showReport === "number";

    window.updateModalImg = (images, i) => {
      this.setState({
        modalImages: images,
        modalI: i,
      });
      console.log(images.length, i);
    };

		return (
      <Right title={group ? group.name : ""} token={this.props.auth} lang={this.props.lang}>
        
          {
            SHOW_REPORT ?
            <Right title={LANG.REPORT} onlyContent={1} noHeight={1}>
              <button
              onClick={() => {
                const target = this.state.searchData.length > 0 ? this.state.searchData : this.state.data; 
                const next = target.findIndex(d => d.id == this.props.routeParams.id);
                history.push(`reports/${this.props.routeParams.group}/${target[next + 1].id}`);
              }} 
              style={{position: "fixed", top: "20px", right: "20px", padding: "10px", fontSize: "20px", zIndex: "999"}}>&#8594;</button>
              <div className="modal fade bs-example-modal-lg imgModal" ref="ifmgModal" tabIndex="-1" role="dialog" aria-hidden="true" style={{"display": "none"}}>
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">

                    <div className="modal-header">
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                      </button>
                      <h4 className="modal-title" id="myModalLabel2">{phpLang['IMAGE']}</h4>
                    </div>
                    <div className="modal-body" ref="modalBody" style={{"text-align": "center"}} key={this.state.modalI}>
                      <button type="button" onClick={() => this.switchModal(this.state.modalI - 1)} className="btn btn-default" style={{height: "100px", width: "50px", margin: "10px", visibility: this.state.modalI > 0 ? "visible" : "hidden"}}>
                        <i className="fa fa-angle-left" aria-hidden="true"/>
                      </button>
                      <img ref="thumb" style={{"maxWidth":"100%", maxHeight: "76vh"}} src={this.state.modalImages[this.state.modalI]}/>
                      <button type="button" onClick={() => this.switchModal(this.state.modalI + 1)} className="btn btn-default" style={{height: "100px", width: "50px", margin: "10px", visibility: this.state.modalImages.length > (this.state.modalI + 1) ? "visible" : "hidden"}}>
                        <i className="fa fa-angle-right" aria-hidden="true"/>
                      </button>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-default" onClick={() => {
                        currDeg -= 90;
                        this.refs.thumb.style.transform = "rotate(" + currDeg + "deg)";
                        this.refs.modalBody.style.overflow = "auto";
                      }}>
                        <i className="fa fa-undo" aria-hidden="true"/>
                      </button>
                      <button type="button" className="btn btn-default" onClick={() => {
                        currDeg += 90;
                        this.refs.thumb.style.transform = "rotate(" + currDeg + "deg)";
                        this.refs.modalBody.style.overflow = "auto";
                      }}>
                        <i className="fa fa-repeat" aria-hidden="true"/>
                      </button>
                      <button type="button" className="btn btn-default" data-dismiss="modal">{i18n.t("Luk")}</button>
                    </div>

                  </div>
                </div>
              </div>
              <Panel title={LANG.GENEREL_INFO} key={repData.id} customIcons={repData.id ? () => 
              <li>
              <a className="collapse-link" target="_blank" href={`/#/publicReport/${repData.id}/${this.props.lang}/${repData.answerHash}?autoprint`/*https://safeallday.dk/administration/getPDF.php?new&f=" + this.props.firm + "&hash=" + repData.secret + "&show=" + repData.id */}>
                <i className="fa fa-print"/>
              </a>
              </li> : null} customIcons2={repData.id ? () => 
              <li style={{cursor: "pointer"}}  onClick={() => this.shareObs(repData)}>
                <p className="collapse-link">
                  <i className="fa fa-share"/>
                </p>
              </li> : null}>
                {/* <FormItem name={LANG.ADDRESS}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.address === "38-40 Railroad Ave, Long Island City, NY 11101, USA" ? LANG.UNKOWN_ADDRESS : repData.address} disabled={true} required=""/>
                </FormItem> */}

                <FormItem name={LANG.CREATED_BY}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.createdBy} disabled={true} required=""/>
                </FormItem>

                <FormItem name={LANG.TIME2}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.unix ? parsePHPtime(repData.unix / 1000) : ""} disabled={true} required=""/>
                </FormItem>
                <FormItem name={LANG.DEPARTMENT}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.departmentName ? `${repData.departmentName}#${repData.department}` : ""} disabled={true} required=""/>
                </FormItem>
                {
                  typeof repData.points === "number" && <FormItem name={LANG.TOTAL_POINTS_O}>
                    <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.points} disabled={true} required=""/>
                  </FormItem>
                }
                {
                  // (repData.questions || []).map((d, key) => 
                  //   d.type !== "deplist" ? <FormItem key={key + "question"} name={langs[this.props.lang][d.name]}>
                  //     {
                  //       d.type === "checkbox" ?
                  //         <div disabled={true} className="form-control tagsinput" style={{"width": "auto", "minHeight": "100px", "height": "100px"}}>
                            
                  //           {
                  //             d.value.map((d, i) => <span className="tag" key={key + "qVal" + i}>{d}</span>)
                  //           }
                  //         </div>
                  //       :
                  //       <textarea className="form-control col-md-7 col-xs-12" disabled={true}>{d.value}</textarea>
                  //         /*<input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={d.value} disabled={true} required=""/>*/
                  //     }
                  //   </FormItem> : null
                  // )
                  
                }

                {/* {
                  repData.images && repData.images.length > 0 ?
                    <FormItem name="Bilag">
                      {
                        repData.images.map((d, key) => 
                          <img key={"image" + key} src={d.indexOf("base64") !== -1 ? d : "https://safeallday.dk/new/img/uploads/" + d} data-toggle="modal"
  data-target=".bs-example-modal-lg.imgModal" style={{width: "100px", cursor: "zoom-in", marginRight: "10px"}} onClick={() => {
                            currDeg = 0;
                            this.refs.thumb.style.transform = "rotate(0deg)";
                            this.refs.modalBody.style.overflow = null;
                            this.refs.thumb.src = d.includes("base64") ? d : "https://safeallday.dk/new/img/uploads/" + d;
                          }}/>
                        )
                      }
                    </FormItem>
                  : null
                } */}
                
                
              </Panel>
              
              <Panel title="Rapport">
              <CoolLoader2 show={repData.questions === false} key={repData.questions} type="table"/>
              {
                this.doShit && this.state.currPoints.length > 1 ?
                  <form ref="pointFilerForm" onChange={(e) => this.setState({currFilters: this.refs.currPointsArr.filter((d) => d.checked).map((d) => Number(d.value))})}>
                    <div className="filter-panel">
                    
                    {
                      this.state.currPoints.map((d, key) => <div key={key}>
                        <label>{d}</label> <input type="checkbox" name="type" value={d} key={key} checked={this.state.currFilters.indexOf(d) !== -1} ref={(r) => {
                          if(!this.refs.currPointsArr)
                          {
                            this.refs.currPointsArr = [];
                          }
                          this.refs.currPointsArr[key] = r;
                        }}/>
                      </div>)
                    }
                    </div>
                  </form>
                : null
              }
              
              <table className="table table-striped jambo_table bulk_action dataTable no-footer" style={repData.questions === false ? {"display": "none"} : {}}>
                <thead>
                  <tr className="headings">
                    <th className="column-title">{LANG.QUESTIONS}</th>
                    <th className="column-title">{LANG.ANSWER}</th>
                    <th className="column-title">{LANG.CORRECT}</th>
                  </tr>
              </thead>
                <tbody>
                  {
                    Array.isArray(repData.questions) && repData.questions.map((question, key) => <tr className="headings" key={key}>
                    <td className="column-title">{i18n.t(question.question)}</td>
                    <td className="column-title">
                      {
                        formatQuestionResponse(question, this.state.reportData.sheet.questions, this)
                      }
                    </td>
                    <td className="column-title"></td>
                  </tr>)
                  }
                </tbody>
              </table>
            </Panel>
            {
              repData.hasCase === 1 && 
              <React.Fragment>
                  <Panel title={phpLang['ACTION']}>
                  <form className="form-horizontal form-label-left" action="" method="post" key={repData.id} onSubmit={(e) => {
                    e.preventDefault();
                    var data = {
                      status: this.refs.status.value,
                      owner: this.refs.users.value,
                      comment: this.refs.comment.value,

                      name: this.refs.name.value,
                      mail: this.refs.mail.value,
                      sendUpdate: this._sendUpdate
                    };


                    api("POST", {"type": "addReportHistory", id: this.props.params.id, data}, (d) => {
                      //console.log(d);
                      if(!d.error)
                      {
                        alert(LANG['CHANGES_SAVED']);
                        this.refs.comment.value = "";
                        this.refs.name.value = "";
                        this.refs.mail.value = "";
                        this.getOBS(this.props.params.id);
                        this.getData();
                      }
                    }, this.props.auth, 1);
                  }}>
                    <FormItem name={phpLang['STATUS']}>
                      <select className="form-control col-md-7 col-xs-12" name="status" ref="status">
                        {
                          phpLang['STATUS_ARR'].filter((d, key) => key < 3).map((d, key) => <option key={"statusS" + key} value={key}>{d}</option>)
                        }
                      </select>
                    </FormItem>
                    <FormItem name={phpLang['ASSIGNED_TO']}>
                      <select className="form-control col-md-7 col-xs-12" name="users" ref="users" defaultValue={repData.assigned} onChange={(e) => {
                        this.refs.extraDiv.style.display = e.target.value === "-1" ? "initial" : "none";
                      }}>
                        <option value={""}>{phpLang['CURRENT']}</option>
                        <option value="-1">{phpLang['OTHER_CONTACT']}</option> 
                      {
                        this.state.users.map((d, key) => <option key={"user" + key} value={d.id}>{d.fullName}#{d.id}</option>)
                      }
                      </select>
                    </FormItem>
                    <div ref="extraDiv" style={{display: "none"}}>
                      <FormItem name={phpLang['NAME']}>
                        <input type="text" name="name" ref="name" className="form-control col-md-7 col-xs-12"/>
                      </FormItem>
                      <FormItem name={phpLang['MAIL']}>
                        <input type="text" name="mail" ref="mail" className="form-control col-md-7 col-xs-12"/>
                      </FormItem>
                    </div>
                    <FormItem name={phpLang['COMMENT']}>
                      <textarea className="form-control col-md-7 col-xs-12" name="comment" ref="comment"></textarea>
                    </FormItem>
                    <FormItem>
                      <button ref="send" onClick={() => this._sendUpdate = false} type="submit" className="btn btn-success">{i18n.t("UPDATE")}</button>
                      <button ref="send" onClick={() => this._sendUpdate = true} type="submit" value="test" className="btn btn-success">{i18n.t("Send update")}</button>
                    </FormItem>
                  </form>
                </Panel>
                <Panel title={phpLang.HISTORY}>
                  <div className="table-responsive">
                    <table className="table table-striped jambo_table bulk_action">
                      <thead>
                        <tr className="headings">
                          <th className="column-title">{phpLang.ACTION}</th>
                          <th className="column-title">{phpLang.COMMENT}</th>
                          <th className="column-title">{phpLang.BY}</th>
                          <th className="column-title">{phpLang.RESPONSIBLE}</th>
                          <th className="column-title">{phpLang.STATUS}</th>
                          <th className="column-title">{phpLang.DATE}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          repData.history.map((d, key) => 
                            <tr key={"history" + key} className="even">
                              <td>{phpLang[d.action]}</td>
                              <td>{d.comment}</td>
                              <td>{d.createdBy || d.externalName}</td>
                              <td>{d.owner === 31 ? d.externalName : d.ownerName}</td>
                              <td>{phpLang['STATUS_ARR'][d.status]}</td>
                              <td>{parsePHPtime(d.unix / 1000)}</td>
                            </tr>)
                        }
                        
                      </tbody>
                  </table>
                  </div>
                </Panel>
              </React.Fragment>
            }
            
            </Right>: ""
          }

        <Right title={LANG.ANSWERS} onlyContent={1} noHeight={1}>
              {/* <ChartMaker types={["OBS_TYPES"]} typeData={[{type: "OBS_TYPES", onClick: (label, value) => this.overViewTable.search(label).draw()}]} 
                          interval={false} auth={this.props.auth} lang={this.props.lang} />
     

          {
            this.props.firm !== "18" ?
              <Panel title={LANG.MAP} size="half">
              {
                this.state.data && this.state.data.data ? 
                <Maps style={{height: "380px"}} key={this.state.data.data.length} data={this.state.data.data.map((d, key) => {
                    if(d.gps.length === 2)
                    {
                      return d.gps;
                    }
                  }).filter((d) => d[0] !== 40.73061 && d[1] !== -73.935242)}/>
                : <CoolLoader show={1} type="worldMap" style={{minHeight: "180px"}}/>
              }
              </Panel>
            : null
          } */}
          
          <Panel 
          title={LANG.VIEW}
          customIcons2={() => <li>
          <a className="collapse-link" onClick={() => {
            // this.refs.pdfForm.submit()
            const boxes = this.checkedObs.map(rowData => rowData.id + "," + rowData.answerHash);///checkBoxes.filter(d => d.checked).map(d => d.value);
            window.open(`#/multiPublicReport/${this.props.lang}/${JSON.stringify(boxes)}`);
          }}>
            <i className="fa fa-file-pdf-o"/>
          </a>
            {/* <button type="submit" style={{display: "none"}} onClick={() => {
     

            }}>Print</button> */}
          </li>}
          customIcons={() => <li>
            <label htmlFor="extObs">{LANG.SHOW_EXT_OBS}</label> <input id="extObs" onChange={(e) => {
              this.setState({showExtObs: e.target.checked});
            }} type="checkbox" defaultChecked={this.state.showExtObs}/>
            </li>}
          >
            
  					<div className="table-responsive" key={this.state.showExtObs ? "321" : "123"}>
            <CoolLoader2 show={!this.state.data} type="table"/>
              {
                this.state.data &&( this.state.departmentsRaw || 1) ? 
                <div className="virtualContainerz" ref="virtaulCont">
                  <div className="searchContainer">
                    <input
                      className="searchBox"
                      placeholder={LANG.DATA_OPTIONS.language.search}
                      ref="searchBox"
                      onChange={debounce((el) => {
                        //this.parseData(this.refs.searchBox.value);
                        this.setState({
                          search: this.refs.searchBox.value
                        });
                        requestAnimationFrame(() => this.parseData(this.refs.searchBox.value));
                      }, 500)}
                      onSubmit={(e) => e.preventDefault()}
                      />
                  </div>
                  <div className="tableContainer">
                  {/* <form method="POST" action={"https://safeallday.dk/administration/getPDFs.php?f=" + this.props.firm} target="_blank" ref="pdfForm"> */}
                  
                  <ExcellFilter 
                    visible={this.state.showFilter}
                    data={this.state.filterData}
                    allData={this.state.data}
                    key={this.state.filterKey}
                    dataKey={this.state.filterKey}
                    x={this.state.filterX}
                    updateData={data => this.setState({searchData: data})}
                  />
                  <Table
                    ref="virtualTable"
                    width={this.state.tableWidth}
                    height={900}
                    headerHeight={40}
                    rowHeight={40}
                    key={this.state.keyBuster}
                    onHeaderClick={({columnData, dataKey, event}) => {
                      // this.setState({
                      //   sortCol: dataKey,
                      //   sortType: this.state.sortCol === dataKey && this.state.sortType === "ASC" ? "DESC": "ASC"
                      // });
                      // requestAnimationFrame(() => this.parseData());
                      let data = [];
                      if(dataKey !== "extraFieldText")
                      {
                        data = this.state.data.map(d => d[dataKey]).filter((d, i, arr) => arr.indexOf(d) === i).map(d => ({
                          key: dataKey,
                          value: d,
                          name: this.keyFormatter(dataKey, d),
                        }));
                      }else{
                        // data = this.state.data.map(d => d[dataKey]).filter((d, i, arr) => arr.indexOf(d) === i).map(d => ({
                        //   key: dataKey,
                        //   value: d,
                        //   name: this.keyFormatter(dataKey, d),
                        // }));
                        // const extra = this.state.data[0].extras.find(q => q.question === event.target.innerText);
                        let extra = false;
                        for(let i = 0; i < this.state.data.length; i++)
                        {
                          const curr = this.state.data[i];
                          const check = curr.extras.find(q => q.question.toLowerCase() === event.target.innerText.toLowerCase());
                          const check2 = curr.extras.find(q => i18n.t(q.question).toLowerCase() === event.target.innerText.toLowerCase());
                          if(check || check2)
                          {
                            extra = check || check2;
                            break;
                          }
                        }
  
                        data = this.state.data.map(d => d.extras.find(a => a.question === extra.question))
                                  .filter(d => d)
                                  .map(d => d.textAnswer || d.answer)
                                  .filter((d, i, arr) => d && arr.indexOf(d) === i)
                                  .map(d => ({
                          key: dataKey,
                          value: d,
                          name: this.keyFormatter(dataKey, d),
                        }));

                      }

                      const bounds = event.target.getBoundingClientRect();
                      this.setState({
                        showFilter: dataKey === this.state.filterKey ? !this.state.showFilter : true,
                        filterKey: dataKey,
                        filterData: data,
                        filterX: (bounds.x - 330) || 0,
                      });
                    }}
                    rowCount={(this.state.data ? this.state.searchData : []).length}
                    rowGetter={({index}) => this.state.searchData[index]}>
                    <Column 
                      label="" dataKey="time" width={20} 
                      cellRenderer={({rowData}) => <input 
                          type="checkbox" name="ids[]"
                          data-hash={rowData.answerHash} value={rowData.id + "," + rowData.answerHash} ref={(inp) => checkBoxes.push(inp)}
                          defaultChecked={this.checkedObs.some(d => d.id === rowData.id)}
                          onChange={(e) => {
                            if(e.target.checked)
                            {
                              this.checkedObs.push({
                                id: rowData.id,
                                answerHash: rowData.answerHash,
                              });
                            }else{
                              this.checkedObs = this.checkedObs.filter(d => d.id !== rowData.id);
                            }
                          }} />}
                      />
                    <Column  label="#" dataKey="id" width={50} />
                    
                    {
                      this.state.sheets.length > 1 && <Column label={LANG.TYPE} dataKey="name" width={100} />
                    }
                    <Column 
                      label={LANG.STARTED_DATE} dataKey="unix" width={150} 
                      cellRenderer={({cellData}) => parsePHPtime(cellData / 1000)}
                      />
                      <Column label={LANG.BY} dataKey="createdBy" width={150}
                      cellRenderer={({cellData}) => {
                        return cellData ? cellData : "";
                      }}
                      />
                      
                    {
                      extras.map((extra, i) => <Column 
                        label={i18n.t(extra.question)} dataKey="extraFieldText" data-extraI={i} width={100} 
                        cellRenderer={({rowData}) => this.extraFieldFormatter(extra.type, rowData.extras.filter(d => d.questionID === extra.questionID))}
                        />)
                    }
                    {
                      this.state.hasCase && <Column label={LANG.STATUS} dataKey="status" width={130} 
                      cellRenderer={({cellData, rowData}) => {
                        // const isOwnDepartment = rowData.department ? this.state.myDeps.indexOf(Number(rowData.department)) !== -1 : true;
                        // let customStatus = !isOwnDepartment ? 3 : cellData;
                        return <p style={{color: actionColors[rowData.status]}}>
                                <i className="fa fa-circle" aria-hidden="true"></i> {LANG.STATUS_ARR[rowData.status]}
                        </p>;
                      }}
                      />
                    }
                    {/* {
                      this.state.extraFields.map((d, key) => <Column
                      key={key}
                      label={APP_LANG[d.langCode]} dataKey="id" flexShrink={1} flexGrow={3} width={(window.innerWidth - 250) / 16} 
                      cellRenderer={({cellData, rowData}) => {
                        let extras = this.state.data.extras.find(dat => dat.parentID == rowData.id);
                        return extras ? extras[LANG.key] : "";
                      }}
                      />)
                    } */}
                    <Column label={LANG.DEPARTMENT} dataKey="department" flexShrink={1} flexGrow={3} width={(window.innerWidth - 250) / 16}
                    cellRenderer={({cellData, rowData}) => {
                      return (rowData.departmentName || "") + "#" + rowData.department;
                      let depKey = rowData.department ? rowData.department : rowData.createdBy.department;
                      return `${depKey}#${this.state.departmentsRaw[depKey]}`;
                    }}
                    />
                    {/* <Column label={LANG.ADDRESS} dataKey="address" flexShrink={1} flexGrow={3} width={(window.innerWidth - 250) / 16} /> */}
                    {/* <Column label={LANG.STATUS} dataKey="status" width={130} 
                      cellRenderer={({cellData, rowData}) => {
                        const isOwnDepartment = rowData.department ? this.state.myDeps.indexOf(Number(rowData.department)) !== -1 : true;
                        let customStatus = !isOwnDepartment ? 3 : cellData;
                        return <p style={{color: actionColors[customStatus]}}>
                                <i className="fa fa-circle" aria-hidden="true"></i> {LANG.STATUS_ARR[customStatus]}
                        </p>;
                      }}
                      /> */}
                    <Column label="" dataKey="id" flexShrink={1} flexGrow={3} width={(window.innerWidth - 250) / 16}
                      cellRenderer={({rowData}) => {
                        return <p className="actionContainer" style={{alignItems: "center"}}>
                          <Link to={"/reports/" + this.props.routeParams.group + "/" + rowData.id} title={LANG.SHOW_OBS}>
                            <i className="fa fa-eye" aria-hidden="true"></i>
                          </Link>
                          <a target="_blank" href={`/#/publicReport/${rowData.id}/${this.props.lang}/${rowData.answerHash}`} title={LANG.EXTERNAL_REP}>
                            <i className="fa fa-external-link" aria-hidden="true"></i>
                          </a>
                          <p onClick={() => this.shareObs(rowData)} title={LANG.SHARE_OBS} style={{margin: "0px"}} className="pointer">
                            <i className="fa fa-share" aria-hidden="true"></i>
                          </p>
                          <p onClick={() => this.deleteObs(0, rowData)} title={LANG.DELETE_OB} style={{margin: "0px"}} className="pointer">
                            <i className="fa fa-trash-o" aria-hidden="true" title={LANG.DELETE_OB}></i>
                          </p>
                        </p>;
                      }}
                      />
                  </Table>
                {/* </form> */}
              </div>
                  </div>
                  : null
              }
          </div>
  				</Panel>
          </Right>
          </Right>);
        }
      }


// WEBPACK FOOTER //
// ./src/components/Observations.js